import { render } from "./PdfContentBody.vue?vue&type=template&id=c9b2aa3c"
import script from "./PdfContentBody.vue?vue&type=script&lang=js"
export * from "./PdfContentBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__